export function mapToObject<T, K>(map: Map<T, K>) {
	return Object.fromEntries(map);
}

export function objectToMap<T extends string | number, K>(obj: Record<T, K>): Map<T, K> {
	return new Map(Object.entries(obj)) as Map<T, K>;
}
